import { querySensitiveGroupList, saveSensitiveGroup, updateSensitiveGroup } from "@/views/zhiji/js/services/service.js";
import { uniqueId, genIndexSearchHandler } from "@/views/zhiji/js/common/util.js";

export default {
    state: {
        sensitiveGroupData: [],
        groupTotals: 0,
        currentGroupId: "",
        sensitiveDetail: "",
        allSensitiveWords: [],
        curPageWords: [],
        isUpdating: "not", // not, sending, success
    },
    mutations: {
        updateCurSensitiveWords(state, data) {
            state.allSensitiveWords = data;
        },
        updateSensitiveGroupList(state, groupData) {
            state.groupTotals = groupData.totalGroups;
            state.currentGroupId = groupData.groupListData[0] && groupData.groupListData[0].uId;
            state.sensitiveDetail = groupData.groupListData[0];
            state.allSensitiveWords = groupData.groupListData[0] && groupData.groupListData[0].wordsArr || [];
            state.sensitiveGroupData.splice(0, state.sensitiveGroupData.length, ...groupData.groupListData);
        },
        updateCurrentId(state, uId) {
            state.currentGroupId = uId;
            state.sensitiveGroupData.forEach(item => {
                if (item.uId === uId) {
                    state.sensitiveDetail = item;
                }
            });
        },
        editUpdateSensitive(state, data) {
            sensitiveWordUpdate(state.sensitiveDetail, data, state);
        },
        getSensitiveListData(state, data) {
            // 前端模拟分页
            state.curPageWords = pagInation(parseInt(data.pageNo), parseInt(data.pageSize), state.allSensitiveWords);
        },
        updatingSaveState(state, data) {
            state.isUpdating = data.isUpdating;
        }
    },
    actions: {
        querySensitiveGroupList(context, param) {
            querySensitiveGroupList(param)
                .then(function(groupData) {
                    context.commit("updateSensitiveGroupList", groupData);
                    context.commit("getSensitiveListData", {
                        pageNo: 1,
                        pageSize: 20
                    });
                })
                .catch(err => {
                    context.dispatch("showModal", {
                        type: "MessageModal",
                        data: {
                            type: "tip",
                            message: err.message
                        }
                    });
                });
        },
        saveSensitiveGroup(context, param) {
            saveSensitiveGroup(param)
                .then(() => {
                    context.dispatch("querySensitiveGroupList", {
                        page: 1
                    });
                })
                .catch(err => {
                    context.dispatch("showModal", {
                        type: "MessageModal",
                        data: {
                            type: "tip",
                            message: err.message
                        }
                    });
                });
        },
        updateSensitiveGroup(context, param) {
            if(param.status === "online") {
                context.commit("updatingSaveState", { isUpdating: "sending" });
            }
            updateSensitiveGroup(param)
                .then(() => {
                    if(param.status === "online") {
                        context.commit("updatingSaveState", { isUpdating: "success" });
                    }
                    context.dispatch("querySensitiveGroupList", {
                        status: ""
                    });
                })
                .catch(err => {
                    context.commit("updatingSaveState", { isUpdating: "not" });
                    context.dispatch("showModal", {
                        type: "MessageModal",
                        data: {
                            type: "tip",
                            message: err.message
                        }
                    });
                });
        }
    }
};

// 修改敏感词总入口
function sensitiveWordUpdate(editWords, data, state) {
    const handlers = {
        addContent: wordsContentAdd,
        deleteContent: wordsContentDelete,
        updateContent: wordsContentUpdate
    };

    handlers[data.type].call(null, editWords, data, state);
}

// 新增敏感词
function wordsContentAdd(sensitiveWords, data, state) {
    data.newWords.map(value => {
        sensitiveWords.wordsArr.unshift({
            uId: uniqueId(),
            word: value,
            updateState: "add"
        });
    });
    sensitiveWords.updateState = "update";
    state.allSensitiveWords = sensitiveWords.wordsArr;
}

// 敏感词删除
function wordsContentDelete(sensitiveWords, data, state) {
    if (data.wordItem.length > 0) {
        data.wordItem.forEach(uId => {
            deleteItemByUId(sensitiveWords.wordsArr, { uId });
        });
        sensitiveWords.updateState = "update";
    }

    sensitiveWords.wordsArr = sensitiveWords.wordsArr.map(item => {
        return {
            ...item,
            checked: false
        };
    });

    state.allSensitiveWords = sensitiveWords.wordsArr;
}

// 敏感词更新
function wordsContentUpdate(sensitiveWords, data, state) {
    if (data.lang) {
        sensitiveWords.lang = data.lang;
    }
    if (data.wordItem) {
        updateItemByUId(sensitiveWords.wordsArr, data.wordItem);
        updateItemByUId(state.curPageWords, data.wordItem);
    }
    if (data.wordArr) {
        sensitiveWords.wordsArr = data.wordArr;
    }
    if (data.title) {
        sensitiveWords.classify = data.title;
    }
    sensitiveWords.updateState = "update";
}

// 更新并且更改元素状态抽象函数 uId, updateState
function updateItemByUId(items, newItem) {
    let itemIdx = genIndexSearchHandler("uId")(items, newItem.uId);
    let item = items[itemIdx];

    if (item.updateState !== "add") {
        item.updateState = "update";
    }

    let updatedItem = Object.assign({}, item, newItem);
    items.splice(itemIdx, 1, updatedItem);
}

// 删除或更改元素状态抽象函数 uId, updateState
function deleteItemByUId(items, newItem) {
    let itemIdx = genIndexSearchHandler("uId")(items, newItem.uId);
    let item = items[itemIdx];

    if (item && item.updateState == "add") {
        items.splice(itemIdx, 1);
    } else if (item) {
        item.updateState = "delete";
    }
}

//  前端分页函数
function pagInation(curPage, pageLength, dataArray) {
    var offset = (curPage - 1) * pageLength;
    return offset + pageLength >= dataArray.length ? dataArray.slice(offset, dataArray.length) : dataArray.slice(offset, offset + pageLength);
}
